(function () {
    require('sweetalert');
    jQuery('.card-options a').click(function (e) {
        var url = this.href;
        e.preventDefault();
        swal(
            {
                title: gmtrans('dashboard.saved_cards.modal_cancel_title'),
                text: gmtrans('dashboard.saved_cards.modal_cancel_explanation'),
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: gmtrans('dashboard.saved_cards.modal_cancel_button_confirm'),
                closeOnConfirm: true,
                cancelButtonText: gmtrans('dashboard.saved_cards.modal_cancel_button_cancel'),
            },
            function () {
                window.location = url;
            }
        );
    });
})();
